<template>
  <div class="display-name">
    <VcAvatar v-if="showAvatar"
              size="x-sm" :image-path="contact.photo_path" :name="contact.full_name" :color-id="contact.color_id"/>
    <v-icon v-if="icon">{{icon}}</v-icon>
    <span class="display-name__name"
          :class="{'display-name__name--with-image': showAvatar && contact.photo_path, 'display-name__name--clickable': isClickable}">
      <span :class="contactNameClass"
            data-testid="contactName"
            @click="navigate({source: 'contact'})">
        {{contact.full_name}}
      </span>
      <span v-if="showMatterName"
            class="display-name__matter"
            data-testid="matterName"
            @click="navigate({source: 'matter'})">
        {{matter.display_name}}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "DisplayName",
  props: {
    matter: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    isClickable: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    showMatterName() {
      return this.matter.display_name && this.matter.display_name !== this.contact.full_name;
    },
    contactNameClass() {
      return this.showMatterName ? 'display-name__contact' : 'display-name__matter';
    }
  },
  methods: {
    navigate({ source }) {
      if (!this.isClickable) return;
      if (this.isMobile) {
        this.$frontageApi.navigateTo('app.client', {
          tab: source === 'contact' ? 'contact' : 'info',
          uid: this.contact.uid,
          matter_uid: this.matter.uid
        })
      } else {
        this.$frontageApi.navigateTo('app.client', {uid: this.contact.uid, matter_uid: this.matter.uid});
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.display-name {
  font-size: 13px;
  line-height: 24px;

  .v-icon {
    color: $black-color-2;
    font-size: 20px;
    margin-inline-end: 5px;
    position: relative;
    top: -2px;
  }

  &__name {

    &--with-image {
      position: relative;
      top: -7px;
    }

    &--clickable {
      cursor: pointer;
    }
  }

  &__contact {
    color: $grey-color-6;
    margin-inline-end: 8px;
    padding-inline-end: 5px;
    border-inline-end: 1px solid $grey-color-12;
  }

  .avatar-wrapper {
    display: inline-block;
    margin-inline-end: 8px;
  }
}
</style>
